import { render, staticRenderFns } from "./SectionLoader.vue?vue&type=template&id=8bc7a146&scoped=true&"
import script from "./SectionLoader.vue?vue&type=script&lang=js&"
export * from "./SectionLoader.vue?vue&type=script&lang=js&"
import style0 from "./SectionLoader.vue?vue&type=style&index=0&id=8bc7a146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc7a146",
  null
  
)

export default component.exports